import React, { memo } from 'react';
import OTPInput from "otp-input-react";

import { BodyOne } from '../typography'
import { OTPViewProps } from '../../models';
import CheckBoxWithText from './CheckBoxWithText';
import ResendOTPBlock from '../info/ResendOTPBlock';
import ResendSMSOTPBlock from '../info/ResendSMSOTPBlock';
import { environments } from '../../constants';
import { useAuthStore } from '../../store';

/**
 * OTP entry used on verification, signup, and forgot-password cards.
 * @param {OTPViewProps} props
 */
export const OTPView = memo(({
  OTP,
  disabled,
  verificationCodeDestination,
  isSignUpOTP = false,
  isForgotPassword = false,
  handleSetOTP,
  verifyPhoneNumber = false,
  ...rest
}: OTPViewProps) => {
  const OTPLength = 6;

  const signUpFormInputs = useAuthStore((s) => s.signUpInputs);

  const subTitle = isSignUpOTP || isForgotPassword ? "We sent you a code to your email address:" : "We sent you a code to your number to verify:"

  return (
    <div>
      <BodyOne className="text-center pb-2" style={{ color: "#003EB2" }} >
        {
          isSignUpOTP ?
            "In order to continue, please verify your email and cell phone number" : isForgotPassword ? "In order to continue, please verify the code sent to your email" :
              "In order to continue, please verify your phone number"
        }
      </BodyOne>

      {
        isSignUpOTP ?
          <CheckBoxWithText className="mb-4" />
          : null
      }

      {
        verificationCodeDestination ?
          <BodyOne className="text-center" style={{ color: "#808080" }}>
            {subTitle}
            <span
              className="text-center text-grayPrimary font-bold block pt-1"
              style={{ color: "#808080" }}
            >
              {verificationCodeDestination.replace("+", "*")}
            </span>
          </BodyOne> : null
      }
      <div className='flex justify-center mb-4' >
        <OTPInput
          value={OTP}
          onChange={(value) => {
            handleSetOTP(value)
          }}
          inputClassName="font-bold font-poppins text-lg text-tripplo-200 text-tripplo-200"
          placeholder={[0, 0, 0, 0, 0, 0]}
          autoFocus
          OTPLength={OTPLength}
          otpType="number"
          disabled={disabled}
          className="flex justify-between"
          inputStyles={{
            border: "1px solid #E0E8FA",
            width: 30,
            height: 30,
            borderRadius: 4,
            margin: 5,
            backgroundColor: "transparent",
          }}
          {...rest}
        />
      </div>

      <ResendOTPBlock username={ signUpFormInputs?.username ? signUpFormInputs.username : "" } clientID={environments.REACT_APP_DEPLOY_USER_POOL_WEB_CLIENT_ID} />
      {
        verifyPhoneNumber && <ResendSMSOTPBlock />
      }
    </div>
  )
})
